<template>
  <div>
    <flat-pickr
      v-model="date"
      :config="config"
      class="form-control custom-date-style"
      name="expiry_date[]"
    ></flat-pickr>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      date: new Date(),
      config: {
        altFormat: "Y-m-d",
        dateFormat: "Y-m-d",
        altInput: false,
        enableTime: false,
        disableMobile: true,
        time_24hr: false
      },
    };
  },
  mounted: function () {
    //this.id = this.$el.getAttribute("data-id");
    this.date = this.$attrs["value"];
  },
  components: {
    flatPickr,
  },
};
</script>

<style scoped>
.custom-date-style {
  min-width: 180px;
}
</style>